<script setup>
import MinimalDropdown from '~/components/ui/MinimalDropdown.vue'
import { useFooter } from '~/composables/useFooter.js'
import { useBrand } from '~/composables/useBrand.js'

const { brandWordmark, brandName } = useBrand()

const { columns, legalLinks, locale, langs, onLocaleChange, openCookieSettings, year } = useFooter()
</script>

<template>
  <footer class="bg-night text-white/60 pt-14 px-8 max-md:px-6 pb-8">
    <div class="grid grid-cols-[2fr_1fr_1fr_1fr] max-md:grid-cols-2 gap-12 max-md:gap-8 max-w-[1100px] mx-auto mb-10">
      <div class="max-md:col-span-2">
        <NuxtLink to="/" class="font-black text-lg text-white mb-3 flex items-center gap-2 cursor-pointer">
          <div class="w-7 h-7 rounded-md bg-grad-brand flex items-center justify-center">
            <Icon name="hugeicons:ai-eraser" size="16" style="color: rgb(var(--c-on-brand))" />
          </div>
          {{ brandWordmark }}
        </NuxtLink>
        <p class="text-sm leading-relaxed mb-4 max-w-[240px] max-md:max-w-none">{{ $t('footer.tagline') }}</p>
      </div>

      <div v-for="column in columns" :key="column.titleKey">
        <h4 class="text-xs font-bold tracking-widest uppercase text-white/35 mb-3.5">{{ $t(column.titleKey) }}</h4>
        <NuxtLink
          v-for="link in column.links"
          :key="link.to"
          :to="link.to"
          class="block text-sm text-white/50 mb-2 cursor-pointer transition-colors duration-150 hover:text-white"
        >{{ $t(link.key) }}</NuxtLink>
      </div>
    </div>

    <div class="border-t border-white/10 pt-5 flex justify-between items-center max-w-[1100px] mx-auto text-xs flex-wrap gap-3">
      <span>© {{ year }} {{ brandName }}</span>
      <div class="flex items-center gap-5">
        <NuxtLink v-for="link in legalLinks" :key="link.to" :to="link.to" class="text-white/35 cursor-pointer">{{ $t(link.key) }}</NuxtLink>
        <button class="text-white/35 cursor-pointer" @click="openCookieSettings">{{ $t('footer.configureCookies') }}</button>
        <MinimalDropdown
          :options="langs"
          :model-value="locale"
          @update:model-value="onLocaleChange($event)"
        />
      </div>
    </div>
  </footer>
</template>
